import imageUrlBuilder from "@sanity/image-url";
const sanityClient = require("@sanity/client");
export const client = sanityClient({
  projectId: process.env.REACT_APP_SANITY_PROJECTID || "95hk2kod",
  dataset: process.env.REACT_APP_SANITY_DATASET || "production",
  apiVersion: "2022-01-12", // use current UTC date - see "specifying API version"!
  token: "", // or leave blank for unauthenticated usage
  useCdn: true, // `false` if you want to ensure fresh data
  ignoreBrowserTokenWarning: true,
});

const builder = imageUrlBuilder(client);

export function urlFor(source) {
  return builder.image(source);
}
